export const signupStatus = {
  started: 'STARTED',
  pending: 'PENDING',
  complete: 'COMPLETE',
  error: 'ERROR',
};

export const pingTimeoutError = 'ping test timeout';

export const hostedRegionTimings = {
  APAC: [82, 94, 167],
  EMEA: [57, 65, 103],
  NA: [38, 46, 88],
};
